import { render } from "./LTagLinkName.vue?vue&type=template&id=1d3d2708&scoped=true&ts=true"
import script from "./LTagLinkName.vue?vue&type=script&lang=ts"
export * from "./LTagLinkName.vue?vue&type=script&lang=ts"

import "./LTagLinkName.vue?vue&type=style&index=0&id=1d3d2708&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3d2708"]])

export default __exports__